//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/DisplayableObject.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"ReversedUVPatchColor",1,0],[0,"RipEdgesColor",1,0],[0,"RipEdgesFont",1,0],[0,"RipEdgesWidth",1,0],[0,"Show2DGrid",1,0],[0,"Show3DGrid",1,0],[0,"ULineColor",1,0],[0,"ULineFont",1,0],[0,"ULineWidth",1,0],[0,"UVPatchColor",1,0],[0,"VLineColor",1,0],[0,"VLineFont",1,0],[0,"VLineWidth",1,0]],[[["display"],"DisplayDistortion",{},1,0]],[]];
SPLM.Preferences.TextureModelingPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.TextureModelingPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;